export default __webpack_public_path__ + "static/media/icon-1-active.96345973.svg";